export default function showHideMenu(){
    const element = document.querySelector('.nav-menu__mobile')
    if(element.classList.contains('hide')){
        element.classList.remove('hide')
    } else{
        element.classList.add('hide')
    }    
}